"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgBellOff = function SvgBellOff(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M12.293 12.293a1 1 0 011.414 0l22 22a1 1 0 01-1.414 1.414L28.585 30H15c-.95 0-1.346-1.183-.648-1.763l.093-.07c.033-.021.14-.11.298-.277.293-.309.593-.719.88-1.244C16.476 25.08 17 22.9 17 20.002a6.86 6.86 0 01.149-1.437l-4.856-4.858a1 1 0 010-1.414zm12.572 20.205a1 1 0 011.73 1.004 3 3 0 01-5.19 0 1 1 0 011.73-1.004l.065.099a1 1 0 001.665-.099zM26.585 28l-7.588-7.589c-.05 3.028-.643 5.403-1.62 7.193-.075.138-.15.27-.227.396h9.435zm.721-14.179c2.278 1.22 3.694 3.623 3.69 6.206l-.002-.043.003.531c.024 1.244.178 2.497.466 3.706l.132.515a1 1 0 11-1.93.528A18.89 18.89 0 0129 20.519l.001-.535-.005-.215a5 5 0 00-7.77-3.937 1 1 0 11-1.11-1.664 7 7 0 017.191-.347z",
    id: "bell-off_svg__a"
  }));
};

var _default = SvgBellOff;
exports["default"] = _default;